import type { Ref } from 'vue';
import type { RegionTag } from '@/shared/api/experience';
import { SpecialTagsOrder, specialTagsSlugs } from '@/widgets/rubricsBlock/tour';
import type { ContextType } from '@/entities/rubrics';

export function useTourRegionTagsFiltering(regionTags: Ref<RegionTag[] | undefined>, context: Ref<ContextType>) {
  const specialTags: Ref<RegionTag[]> = ref([]);
  const popupTags: Ref<RegionTag[]> = ref([]);
  const rubricsTags: Ref<RegionTag[]> = ref([]);

  const filterTags = (tags: RegionTag[] = []) => {
    const special: RegionTag[] = [];
    const popup: RegionTag[] = [];

    const filteredTags = tags.reduce((acc, tag) => {
      const slug = tag.slug ?? '';
      const { is_hidden: isHidden, is_seo_only: isSeoOnly } = tag.flags || {};
      const hasExperience = !!tag?.counters?.[`${context.value}_count`];

      if (specialTagsSlugs.includes(slug) && !isHidden && !isSeoOnly) {
        special.push(tag);
      } else if (isHidden || isSeoOnly) {
        if (!isSeoOnly) {
          popup.push(tag);
        }
      } else if (hasExperience) {
        popup.push(tag);
      }

      if (!isHidden && !isSeoOnly && !specialTagsSlugs.includes(slug) && hasExperience) {
        acc.push(tag);
      }

      return acc;
    }, [] as RegionTag[]);

    specialTags.value = special;
    popupTags.value = popup;

    return filteredTags;
  };

  const sortSpecialTags = () => {
    specialTags.value.sort(
      (a, b) =>
        (SpecialTagsOrder[a?.slug] || SpecialTagsOrder.default) -
        (SpecialTagsOrder[b?.slug] || SpecialTagsOrder.default),
    );
  };

  watch(
    () => regionTags.value,
    () => {
      specialTags.value = [];
      popupTags.value = [];

      const filteredTags = filterTags(regionTags.value ?? []);

      sortSpecialTags();
      popupTags.value = specialTags.value.concat(popupTags.value);
      rubricsTags.value = specialTags.value.concat(filteredTags);
    },
    { deep: true, immediate: true },
  );

  return { popupTags, rubricsTags };
}
